export default {
  Primary: 'Chính',
  Recent: 'Liên quan',
  All: 'Tất cả',
  'Same Visit ID': 'Cùng mã hồ sơ',
  'Same Modality': 'Cùng loại thiết bị',
  'Same Procedure': 'Cùng dịch vụ',
  History: 'Lịch sử',
  'Patient Info': 'Thông tin',
  'Exams': 'Danh sách ca chụp',
};
